import { jsxs as h, jsx as s } from "react/jsx-runtime";
import { MinusIcon as p } from "../../icons/MinusIcon.js";
import { PlusIcon as v } from "../../icons/PlusIcon.js";
import { TrashIcon as N } from "../../icons/TrashIcon.js";
import w from "clsx";
import '../../_assets/QuantityEditor.Df3QjgMX.css';const $ = "_root_1i2r6_44", B = "_btn_1i2r6_55", j = "_disabled_1i2r6_76", D = "_remove_1i2r6_80", P = "_count_1i2r6_84", W = "_asBtn_1i2r6_99", x = "_asCard_1i2r6_99", e = {
  root: $,
  btn: B,
  disabled: j,
  remove: D,
  count: P,
  "brand-green": "_brand-green_1i2r6_96",
  asBtn: W,
  asCard: x,
  "brand-dark": "_brand-dark_1i2r6_106",
  "brand-white": "_brand-white_1i2r6_116",
  "orange-1": "_orange-1_1i2r6_126",
  "stone-1": "_stone-1_1i2r6_136",
  "green-1": "_green-1_1i2r6_146",
  "green-2": "_green-2_1i2r6_156",
  "green-3": "_green-3_1i2r6_166",
  "black-1": "_black-1_1i2r6_176",
  "black-2": "_black-2_1i2r6_186",
  "dark-2": "_dark-2_1i2r6_196",
  "grey-1": "_grey-1_1i2r6_206",
  "grey-2": "_grey-2_1i2r6_216",
  "grey-3": "_grey-3_1i2r6_226",
  "grey-4": "_grey-4_1i2r6_236",
  "grey-5": "_grey-5_1i2r6_246",
  "grey-6": "_grey-6_1i2r6_256",
  "grey-7": "_grey-7_1i2r6_266",
  "mint-1": "_mint-1_1i2r6_276",
  "mint-2": "_mint-2_1i2r6_286",
  "mint-3": "_mint-3_1i2r6_296",
  "secondary-grey-1": "_secondary-grey-1_1i2r6_306",
  "secondary-grey-4": "_secondary-grey-4_1i2r6_316",
  "secondary-grey-3": "_secondary-grey-3_1i2r6_326",
  "status-error": "_status-error_1i2r6_336",
  "status-error-bg": "_status-error-bg_1i2r6_346",
  "status-warning": "_status-warning_1i2r6_356",
  "status-warning-bg": "_status-warning-bg_1i2r6_366",
  "status-success": "_status-success_1i2r6_376",
  "status-success-bg": "_status-success-bg_1i2r6_386",
  "status-info": "_status-info_1i2r6_396",
  "status-info-bg": "_status-info-bg_1i2r6_406",
  "brand-green-new": "_brand-green-new_1i2r6_416",
  "brand-dark-new": "_brand-dark-new_1i2r6_426",
  "brand-white-new": "_brand-white-new_1i2r6_436",
  "brown-new": "_brown-new_1i2r6_446",
  "brown-hover-new": "_brown-hover-new_1i2r6_456",
  "stone-new": "_stone-new_1i2r6_466",
  "black-new": "_black-new_1i2r6_476",
  "red-1-new": "_red-1-new_1i2r6_486",
  "red-2-new": "_red-2-new_1i2r6_496",
  "red-stop-new": "_red-stop-new_1i2r6_506",
  "grey-1-new": "_grey-1-new_1i2r6_516",
  "grey-2-new": "_grey-2-new_1i2r6_526",
  "grey-3-new": "_grey-3-new_1i2r6_536",
  "grey-4-new": "_grey-4-new_1i2r6_546",
  "grey-5-new": "_grey-5-new_1i2r6_556",
  "grey-6-new": "_grey-6-new_1i2r6_566",
  "grey-7-new": "_grey-7-new_1i2r6_576",
  "off-white": "_off-white_1i2r6_586",
  "status-error-new": "_status-error-new_1i2r6_596",
  "status-error-bg-new": "_status-error-bg-new_1i2r6_606",
  "status-warning-new": "_status-warning-new_1i2r6_616",
  "status-warning-bg-new": "_status-warning-bg-new_1i2r6_626",
  "status-success-new": "_status-success-new_1i2r6_636",
  "status-success-bg-new": "_status-success-bg-new_1i2r6_646",
  "status-info-new": "_status-info-new_1i2r6_656",
  "status-info-bg-new": "_status-info-bg-new_1i2r6_666",
  "secondary-grey-2": "_secondary-grey-2_1i2r6_676",
  "color-success-filied-default": "_color-success-filied-default_1i2r6_686",
  "slide-in-out": "_slide-in-out_1i2r6_1",
  "fade-in-out": "_fade-in-out_1i2r6_1"
}, z = ({
  quantity: r,
  max: i,
  min: g = 1,
  mode: d = "subscription",
  useTrashIcon: u,
  className: b,
  disabled: t,
  onChange: _,
  onRemove: c,
  onIncrementDisabled: a,
  dataTestId: n = "quantity-editor"
}) => {
  const y = () => {
    r > g ? _ && _(r - 1) : c ? c() : _ && _(0);
  }, l = () => {
    _ && _(r + 1);
  }, f = () => {
    if (t) {
      a && a();
      return;
    }
    if (i !== void 0 && r >= i) {
      a && a();
      return;
    }
    l();
  }, m = t || r <= g && !c, k = t || i !== void 0 && r >= i, o = u && d === "order" && r === 1;
  return /* @__PURE__ */ h("div", { className: w(e.root, b), "data-testid": n, children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        disabled: m,
        onClick: y,
        className: w(e.btn, o ? e.remove : e.minus),
        "aria-label": o ? "Remove item" : "Decrease quantity",
        "data-testid": o ? `${n}-remove` : `${n}-decrease`,
        children: o ? /* @__PURE__ */ s(N, {}) : /* @__PURE__ */ s(p, { strokeWidth: 1 })
      }
    ),
    /* @__PURE__ */ s("span", { className: e.count, "data-testid": `${n}-value`, children: r }),
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        disabled: t,
        onClick: f,
        className: w(e.btn, k && e.disabled),
        "aria-label": "Increase quantity",
        "data-testid": `${n}-increase`,
        children: /* @__PURE__ */ s(v, { hasPadding: !1, strokeWidth: 1 })
      }
    )
  ] });
};
export {
  z as QuantityEditor
};
